export const cities = [
    'Bath',
    'Birmingham',
    'Bradford',
    'Brighton & Hove',
    'Bristol',
    'Cambridge',
    'Canterbury',
    'Carlisle',
    'Chelmsford',
    'Chester',
    'Chichester',
    'Colchester',
    'Coventry',
    'Derby',
    'Doncaster',
    'Durham',
    'Ely',
    'Exeter',
    'Gloucester',
    'Hereford',
    'Kingston-upon-Hull',
    'Lancaster',
    'Leeds',
    'Leicester',
    'Lichfield',
    'Lincoln',
    'Liverpool',
    'London',
    'Manchester',
    'Milton Keynes',
    'Newcastle-upon-Tyne',
    'Norwich',
    'Nottingham',
    'Oxford',
    'Peterborough',
    'Plymouth',
    'Portsmouth',
    'Preston',
    'Ripon',
    'Salford',
    'Salisbury',
    'Sheffield',
    'Southampton',
    'Southend-on-Sea',
    'St Albans',
    'Stoke on Trent',
    'Sunderland',
    'Truro',
    'Wakefield',
    'Wells',
    'Westminster',
    'Winchester',
    'Wolverhampton',
    'Worcester',
    'York',
];
